import { render, staticRenderFns } from "./search-provider.vue?vue&type=template&id=bb688932&scoped=true"
import script from "./search-provider.vue?vue&type=script&lang=js"
export * from "./search-provider.vue?vue&type=script&lang=js"
import style0 from "./search-provider.vue?vue&type=style&index=0&id=bb688932&prod&lang=scss"
import style1 from "./search-provider.vue?vue&type=style&index=1&id=bb688932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb688932",
  null
  
)

export default component.exports